<template lang="pug">
    Poptip(:title="$t('certsmanage.explainPoptipTitle')" transfer @on-popper-show="get")
        template(slot="content")
            div(style="display: flex;" v-for="(item,index) in visibleCertItemStatus" :key="item.id")
                p {{ certItemLabel(item.id, index) }}
                Tooltip(:disabled="!item.description" max-width="200")
                    Icon(:type="explainIcon(item.status)" :size="24" :color="explainIconColor(item.status)")
                    template(slot="content")
                        p {{ item.description }}
        Icon(:type="iconType", :size="24", :color="iconColor")
</template>

<script>
import { assignDefaultValue, colorNames } from "@/libs/rcmTableFieldsFunction";
import { _certRequirements } from "@/api/validate";

export default {
    name: "DomainCertPoptip",
    props: {
        params: {
            type: Object,
            required: true,
        },
        isIpDomain: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            certItemStatus: [
                { id: "schemeStatus", status: false },
                { id: "portStatus", status: false },
                { id: "cnameStatus", status: false },
                { id: "caaStatus", status: false },
            ],
        };
    },
    methods: {
        async get() {
            // 抓取群組domain申請憑證的狀態
            const getCertRequirements = await _certRequirements({
                groupName: this.params.row.groupName,
                servername: this.params.row.servername,
            });

            const { data, success } = getCertRequirements.data;

            if (!success) {
                this.$Message.error("Record Error.");
                return;
            }

            this.certItemStatus.forEach((item) => {
                if (data[item.id] !== undefined) {
                    item.status = data[item.id];
                }

                // caa欄位另位做處理
                if (item.id === "caaStatus") {
                    item.status = data.checkCAA.status;
                    // caa驗證失敗，加上提示
                    if (!data.checkCAA.status) {
                        item.description = `${this.$i18n.t("certsmanage.caaDescription")}:\n${data.checkCAA.CAA.join(
                            "\n"
                        )}`;
                    }
                }
            });
        },
        certItemLabel(id, index) {
            // IP 域名：第三項改為「IP 為平台提供之服務 IP」（資料仍讀 cnameStatus）
            if (this.isIpDomain && id === "cnameStatus") return this.$i18n.t("certsmanage.explainPoptipContentForIpDomainServiceIp");
            return this.$i18n.t("certsmanage.explainPoptipContentForNonWildcard")[index];
        },
        explainIcon(status) {
            return status ? "md-checkmark" : "md-close";
        },
        explainIconColor(status) {
            return status ? colorNames.green : colorNames.red;
        },
    },
    computed: {
        visibleCertItemStatus() {
            // IP 域名沒有 CAA 檢查
            return this.isIpDomain ? this.certItemStatus.filter((item) => item.id !== "caaStatus") : this.certItemStatus;
        },
        iconType() {
            return this.params.row.hasSystemCert ? "ios-information-circle-outline" : "md-warning";
        },
        iconColor() {
            return this.params.row.hasSystemCert ? "grey" : "orange";
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/DomainCertPoptip.vue